

export function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
}


export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export function checkIfCookieExpired(cookieName) {
  // Get all cookies as an array of "key=value" strings.
  const cookies = document.cookie.split(';');

  // Loop through the cookies to see if the target cookie exists.
  for (let cookie of cookies) {
    // Trim whitespace and check if the cookie starts with the cookieName followed by '='
    if (cookie.trim().indexOf(cookieName + '=') === 0) {
      // The cookie exists, so it hasn’t expired.
      return false;
    }
  }

  // If we get here, the cookie wasn’t found.
  return true;
}
